import { Card } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import PageHeading from "@/v2/components/ui/heading/Page";
import parseUrlToQueryParams from "../../utils/parseUrlToQueryParams";
import { TableToolbar, DataTable } from "@/v2/components/data-table/table";
import { Project } from "@/v2/types";
import {
    ProjectColumn,
    ProjectFilterColumn,
} from "@/v2/components/data-table/columns/Project";
import FindAllProjects from "@/v2/api/project/FindAll";
import AddProject from "./Add";
import AccessControl from "@/v2/components/rbac/AccessControl";

export default function ProjectPage() {
    const [searchParams, _setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);

    const { skip, limit, search, filter } = queryParams;

    const { refetch, ...query } = useQuery({
        queryKey: ["projects", skip, limit, search, filter],
        queryFn: () =>
            FindAllProjects({
                limit: limit ?? 20,
                skip: skip ?? 0,
                search: search,
                filter,
            }),
    });

    return (
        <>
            <div className="flex flex-wrap items-center justify-between gap-4 py-2">
                <PageHeading
                    title="Project Database"
                    description="Manage and monitor all projects in your platform"
                />
                <AccessControl
                    requestedAccess={"POST"}
                    module="PROJECT_MANAGEMENT"
                >
                    <div className="flex gap-4">
                        <AddProject />
                    </div>
                </AccessControl>
            </div>

            <Card className="p-2">
                <TableToolbar<Project>
                    column={ProjectFilterColumn}
                    searchPlaceHolder="Search Projects"
                />

                <DataTable<Project>
                    data={query.data?.data || []}
                    columns={ProjectColumn}
                    loading={query.isLoading || query.isFetching}
                    pagination={query?.data?.pagination!}
                />
            </Card>
        </>
    );
}
